<app-toolbar *ngIf="showHeader" ></app-toolbar>
<ngx-spinner type="ball-spin-clockwise"></ngx-spinner>
<div class="main-wrapper"  fxFlex>
  <router-outlet></router-outlet>
</div>